/* __next_internal_client_entry_do_not_use__ Translate auto */import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslations } from "next-intl";
// 国际化组件 - ssr组件内文案需要国际化可用
export const Translate = param => {
  let {
    translateKey
  } = param;
  const t = useTranslations();
  if (!translateKey) {
    return "";
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: t(translateKey)
  });
};